module.exports = __webpack_public_path__ + "img/accoun-bind.49f82469.png";